import { render, staticRenderFns } from "./SourcePreview.vue?vue&type=template&id=1b8f591d&scoped=true"
import script from "./SourcePreview.vue?vue&type=script&lang=js"
export * from "./SourcePreview.vue?vue&type=script&lang=js"
import style0 from "./SourcePreview.vue?vue&type=style&index=0&id=1b8f591d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f591d",
  null
  
)

export default component.exports